<main
  class="container-fluid px-0 irembogov-review-service-change-request mt-n5 pt-1">
  <irembogov-irembo-loading-circle-spinner
    *ngIf="isLoadingChangeRequest"></irembogov-irembo-loading-circle-spinner>

  <ng-container *ngIf="!isLoadingChangeRequest">
    <ng-container *ngIf="loadRequestDetailsFailed">
      <div class="col-8 text-center mx-auto mt-5">
        <irembogov-irembo-section-message
          [type]="'danger'"
          [message]="loadFailedErrorCodeMessage.message"
          title="Error Encountered: {{
            loadFailedErrorCodeMessage.code
          }}"></irembogov-irembo-section-message>
        <a [routerLink]="['/services']">
          &lt;&lt; Back to Change Requests List</a
        >
      </div>
    </ng-container>

    <ng-container *ngIf="!loadRequestDetailsFailed">
      <irembogov-change-request-configuration-header-widget
        [readyForSaveSubmit]="readyForFinalReview"
        [request]="changeRequest"
        [inReviewMode]="true"
        (OnPreviewClick)="toggleFormPreview($event)"
        (OnClickRequirementDoc)="
          onViewRequirementDocs()
        "></irembogov-change-request-configuration-header-widget>

      <div class="d-flex justify-content-end px-4 mt-2">
        <button
          class="btn btn-sm btn-outline-primary"
          (click)="showDiffView = !showDiffView">
          <i class="fas fa-code-compare me-1"></i>
          {{ showDiffView ? 'Hide JSON Changes' : 'View JSON Changes' }}
        </button>
      </div>

      <ng-container *ngIf="changeRequest">
        <div
          class="mt-5 p-5 container rounded bg-white"
          *ngIf="showFormPreview">
          <irembogov-preview-service-change-request-json-formdata-widget
            class="mx-auto"
            *ngIf="
              changeRequestJsonFormData
            "></irembogov-preview-service-change-request-json-formdata-widget>
        </div>

        <irembogov-configure-service-change-request-stepper
          *ngIf="!showFormPreview"
          orientation="vertical"
          [showIndexInLabel]="false"
          [configSteps]="reviewSteps"
          [selectedIndex]="currentConfigStep"
          (selectionChange)="OnStepperChange($event)">
          <cdk-step
            [label]="item.label"
            *ngFor="let item of reviewSteps; let index = index"
            [hasError]="reviewSteps[index].hasError"
            [completed]="reviewSteps[index].isComplete">
            <ng-container
              *ngTemplateOutlet="getCurrentTemplate(index)"></ng-container>
          </cdk-step>
        </irembogov-configure-service-change-request-stepper>
      </ng-container>
    </ng-container>
  </ng-container>
</main>

<ng-template #reviewOverview>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-metadata-overview
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequest]="changeRequest"
    (reviewMetadataCompleted)="
      onStepFormSubmitted($event)
    "></irembogov-review-metadata-overview>

  <div
    *ngIf="!isLoadingChangeRequestDetails && showDiffView"
    class="d-flex p-3">
    <div class="flex-grow-1 me-3">
      <irembogov-json-diff-viewer
        [oldData]="isServiceUpdate ? activeCrMetadata : null"
        [newData]="changeRequest"
        [loading]="isServiceUpdate && !activeCrDataLoaded"
        [enableLineComment]="true"
        (lineComment)="
          onDiffLineComment($event, EServiceChangeRequestReviewSection.OVERVIEW)
        "
        sectionTitle="Overview">
      </irembogov-json-diff-viewer>
    </div>
    <irembogov-reviewer-issues-entry-form-widget
      class="w-30"
      [changeRequestId]="changeRequest.id"
      [reviewSection]="EServiceChangeRequestReviewSection.OVERVIEW"
      [presetLineSubject]="presetLine$"
      (goToNext)="onStepFormSubmitted($event)">
    </irembogov-reviewer-issues-entry-form-widget>
  </div>
</ng-template>

<ng-template #reviewForm>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-formbuilder-json-editor
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequest]="changeRequest"
    (reviewFormBuilderJsonEditorCompleted)="onStepFormSubmitted($event)">
  </irembogov-review-formbuilder-json-editor>

  <div
    *ngIf="!isLoadingChangeRequestDetails && showDiffView"
    class="d-flex p-3">
    <div class="flex-grow-1 me-3">
      <irembogov-json-diff-viewer
        [oldData]="isServiceUpdate ? activeCrFormData : null"
        [newData]="changeRequestJsonFormData"
        [loading]="isServiceUpdate && !activeCrDataLoaded"
        [enableLineComment]="true"
        (lineComment)="
          onDiffLineComment($event, EServiceChangeRequestReviewSection.FORM)
        "
        sectionTitle="Form Definition">
      </irembogov-json-diff-viewer>
    </div>
    <irembogov-reviewer-issues-entry-form-widget
      class="w-30"
      [changeRequestId]="changeRequest.id"
      [reviewSection]="EServiceChangeRequestReviewSection.FORM"
      [presetLineSubject]="presetLine$"
      (goToNext)="onStepFormSubmitted($event)">
    </irembogov-reviewer-issues-entry-form-widget>
  </div>
</ng-template>

<ng-template #reviewPricing>
  <irembogov-irembo-loading-circle-spinner
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-pricing
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [pricingData]="serviceChangeRequestPricingData"
    [changeRequest]="changeRequest"
    (reviewPricingCompleted)="onStepFormSubmitted($event)">
  </irembogov-review-pricing>

  <div
    *ngIf="!isLoadingChangeRequestDetails && showDiffView"
    class="d-flex p-3">
    <div class="flex-grow-1 me-3">
      <irembogov-json-diff-viewer
        [oldData]="isServiceUpdate ? activeCrPricingData : null"
        [newData]="serviceChangeRequestPricingData"
        [loading]="isServiceUpdate && !activeCrDataLoaded"
        [enableLineComment]="true"
        (lineComment)="
          onDiffLineComment($event, EServiceChangeRequestReviewSection.PRICING)
        "
        sectionTitle="Pricing">
      </irembogov-json-diff-viewer>
    </div>
    <irembogov-reviewer-issues-entry-form-widget
      class="w-30"
      [changeRequestId]="changeRequest.id"
      [reviewSection]="EServiceChangeRequestReviewSection.PRICING"
      [presetLineSubject]="presetLine$"
      (goToNext)="onStepFormSubmitted($event)">
    </irembogov-reviewer-issues-entry-form-widget>
  </div>
</ng-template>

<ng-template #reviewWorkflow>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-workflow-json-entry
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequestJsonWorkflow]="changeRequestJsonWorkflowData"
    [changeRequest]="changeRequest"
    (reviewWorkflowJsonCompleted)="onStepFormSubmitted($event)">
  </irembogov-review-workflow-json-entry>

  <div
    *ngIf="!isLoadingChangeRequestDetails && showDiffView"
    class="d-flex p-3">
    <div class="flex-grow-1 me-3">
      <irembogov-json-diff-viewer
        [oldData]="isServiceUpdate ? activeCrWorkflowData : null"
        [newData]="changeRequestJsonWorkflowData"
        [loading]="isServiceUpdate && !activeCrDataLoaded"
        [enableLineComment]="true"
        (lineComment)="
          onDiffLineComment($event, EServiceChangeRequestReviewSection.WORKFLOW)
        "
        sectionTitle="Workflow Config">
      </irembogov-json-diff-viewer>
    </div>
    <irembogov-reviewer-issues-entry-form-widget
      class="w-30"
      [changeRequestId]="changeRequest.id"
      [reviewSection]="EServiceChangeRequestReviewSection.WORKFLOW"
      [presetLineSubject]="presetLine$"
      (goToNext)="onStepFormSubmitted($event)">
    </irembogov-reviewer-issues-entry-form-widget>
  </div>
</ng-template>

<ng-template #reviewSla>
  <div class="text-center">
    SLA:
    <button class="btn btn-sm btn-primary" (click)="onStepFormSubmitted(true)">
      Next
    </button>
  </div>
</ng-template>

<ng-template #reviewNotifications>
  <div class="text-center">
    Notifications:
    <button class="btn btn-sm btn-primary" (click)="onStepFormSubmitted(true)">
      Next
    </button>
  </div>
</ng-template>

<ng-template #reviewOfficeAssignment>
  <div class="text-center">
    Office Assignment:
    <button class="btn btn-sm btn-primary" (click)="onStepFormSubmitted(true)">
      Next
    </button>
  </div>
</ng-template>

<ng-template #reviewIntegrations>
  <div class="text-center">
    Integrations:
    <button class="btn btn-sm btn-primary" (click)="onStepFormSubmitted(true)">
      Next
    </button>
  </div>
</ng-template>

<ng-template #reviewDocuments>
  <div class="text-center">
    Documents:
    <button class="btn btn-sm btn-primary" (click)="onStepFormSubmitted(true)">
      Next
    </button>
  </div>
</ng-template>

<ng-template #reviewTranslation>
  <irembogov-irembo-loading-circle-spinner
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>
  <irembogov-review-translations
    *ngIf="!isLoadingChangeRequestDetails && !showDiffView"
    [changeRequest]="changeRequest"
    [translationsData]="serviceChangesRequestTranslations"
    (reviewTranslationsCompleted)="onStepFormSubmitted($event)">
  </irembogov-review-translations>

  <div
    *ngIf="!isLoadingChangeRequestDetails && showDiffView"
    class="d-flex p-3">
    <div class="flex-grow-1 me-3">
      <irembogov-json-diff-viewer
        [oldData]="isServiceUpdate ? activeCrTranslationData : null"
        [newData]="serviceChangesRequestTranslations"
        [loading]="isServiceUpdate && !activeCrDataLoaded"
        [enableLineComment]="true"
        (lineComment)="
          onDiffLineComment(
            $event,
            EServiceChangeRequestReviewSection.TRANSLATION
          )
        "
        sectionTitle="Translation">
      </irembogov-json-diff-viewer>
    </div>
    <irembogov-reviewer-issues-entry-form-widget
      class="w-30"
      [changeRequestId]="changeRequest.id"
      [reviewSection]="EServiceChangeRequestReviewSection.TRANSLATION"
      [presetLineSubject]="presetLine$"
      (goToNext)="onStepFormSubmitted($event)">
    </irembogov-reviewer-issues-entry-form-widget>
  </div>
</ng-template>

<ng-template #reviewPreviewSubmit>
  <irembogov-irembo-loading-circle-spinner
    marginTop="8rem"
    *ngIf="
      isLoadingChangeRequestDetails
    "></irembogov-irembo-loading-circle-spinner>

  <irembogov-review-submission
    *ngIf="!isLoadingChangeRequestDetails"
    [changeRequestId]="changeRequest.id"
    (reviewApproved)="OnReviewApproved($event)"
    (reviewRejected)="OnReviewRejected($event)"></irembogov-review-submission>
</ng-template>
